import React from 'react'
import DashboardMaster from '../../../../dashboard/DashboardMaster'
import CurvesContent from './CurvesContent'

const AdminCurves = () => {
  return (
    <DashboardMaster>
      <CurvesContent />
    </DashboardMaster>
  )
}

export default AdminCurves
